import { render } from "./SpinnerModal.vue?vue&type=template&id=7d766f59&scoped=true"
import script from "./SpinnerModal.vue?vue&type=script&lang=js"
export * from "./SpinnerModal.vue?vue&type=script&lang=js"

import "./SpinnerModal.vue?vue&type=style&index=0&id=7d766f59&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d766f59"

export default script